export const color = {
  data () {
    return {
      colors: ['#20a8d8', '#4dbd74', '#684388', '#FFFF00', '#f58231', '#000075', '#46f0f0', '#f032e6', '#bcf60c', '#fabebe', '#008080', '#e6beff', '#9a6324', '#fffac8', '#800000', '#aaffc3', '#808000', '#ffd8b1', '#000075']
    }
  },
  methods: {
    getColorByIndex(index) {
      return this.colors[index]
    },
    getColors() {
      return this.colors
    }
  }
};